import React from 'react';

interface AdminStatCardProps {
  label: string;
  value: string;
  description: string;
  icon?: string;
  color?: 'blue' | 'green' | 'purple' | 'orange';
}

const COLOR_MAP: Record<string, { text: string; ring: string; iconBg: string }> = {
  blue: { text: 'text-blue-700', ring: 'from-blue-500 to-cyan-400', iconBg: 'bg-blue-100' },
  green: { text: 'text-green-700', ring: 'from-green-500 to-emerald-400', iconBg: 'bg-green-100' },
  purple: { text: 'text-purple-700', ring: 'from-purple-500 to-fuchsia-400', iconBg: 'bg-purple-100' },
  orange: { text: 'text-orange-700', ring: 'from-orange-500 to-amber-400', iconBg: 'bg-orange-100' },
};

const AdminStatCard: React.FC<AdminStatCardProps> = ({ label, value, description, icon, color = 'blue' }) => {
  const theme = COLOR_MAP[color] || COLOR_MAP.blue;
  return (
    <div className="bg-white shadow-md rounded-xl overflow-hidden border border-gray-100">
      <div className={`h-1 w-full bg-gradient-to-r ${theme.ring}`} />
      <div className="p-6 flex items-start gap-4">
        {icon && (
          <div className={`w-12 h-12 flex-shrink-0 rounded-lg ${theme.iconBg} flex items-center justify-center text-2xl`}>
            <span aria-hidden="true">{icon}</span>
          </div>
        )}
        <div>
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{label}</div>
          <div className={`text-3xl font-bold mt-1 ${theme.text}`}>{value}</div>
          <div className="text-xs text-gray-500 mt-1">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminStatCard;
